import { render, staticRenderFns } from "./BeginningInventories.vue?vue&type=template&id=b6633a12&scoped=true&"
import script from "./BeginningInventories.vue?vue&type=script&lang=js&"
export * from "./BeginningInventories.vue?vue&type=script&lang=js&"
import style0 from "./BeginningInventories.vue?vue&type=style&index=0&id=b6633a12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6633a12",
  null
  
)

export default component.exports